import { BaseWebComponentRepository } from '../../../../../../framework/BaseWebComponentRepository';
import { GzSearchablePolicyPanelDataProviderFactory } from '../factory/GzSearchablePolicyPanelDataProviderFactory';
import { GzSearchablePolicyPanelBaseDataProvider } from '../dataProvider/GzSearchablePolicyPanelBaseDataProvider';
import { Policy, PolicyCounters } from '@nirvana/shared/dtos/types/policies/common';

export class GzSearchablePolicyPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GzSearchablePolicyPanelDataProviderFactory;
  public dataProvider: GzSearchablePolicyPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GzSearchablePolicyPanelDataProviderFactory(),
    });
  }

  async getPolicyById(policyId: string): Promise<Policy> {
    return this.dataProvider.getPolicyById(policyId);
  }

  async getDefaultPolicy(): Promise<Policy> {
    return this.dataProvider.getDefaultPolicy();
  }

  async getSuggestedNewPolicyName(): Promise<string> {
    return this.dataProvider.getSuggestedNewPolicyName();
  }

  async generateSuggestedCloneName(clonedPolicyName: string): Promise<string> {
    return this.dataProvider.generateSuggestedCloneName(clonedPolicyName);
  }

  async getCounters(policyId: string): Promise<PolicyCounters> {
    return this.dataProvider.getCounters(policyId);
  }
}
